export const MPR_WHEEL_PIXELS_PER_SLICE = 80;
export const MPR_WHEEL_MAX_STEPS_PER_FRAME = 4;
export const MPR_WHEEL_COALESCING_MARKER = 'KAIROS_MPR_WHEEL_COALESCING_2026';

export const normalizeMprWheelDelta = (event) => {
  const mode = event?.deltaMode ?? 0;
  const unit = mode === 1 ? 40 : (mode === 2 ? 800 : 1);
  return (event?.deltaY || 0) * unit;
};

export const consumeMprWheelSteps = (accumulatedPixels) => {
  const pixels = Number.isFinite(accumulatedPixels) ? accumulatedPixels : 0;
  const sign = pixels < 0 ? -1 : 1;
  const rawSteps = Math.floor(Math.abs(pixels) / MPR_WHEEL_PIXELS_PER_SLICE);
  if (rawSteps <= 0) return { steps: 0, remainder: pixels };
  const steps = sign * Math.min(rawSteps, MPR_WHEEL_MAX_STEPS_PER_FRAME);
  return {
    steps,
    remainder: pixels - steps * MPR_WHEEL_PIXELS_PER_SLICE,
  };
};

export const shouldScheduleMprWheelFrame = (accumulatedPixels) => (
  Math.abs(Number.isFinite(accumulatedPixels) ? accumulatedPixels : 0) >= MPR_WHEEL_PIXELS_PER_SLICE
);
